import { render, staticRenderFns } from "./PartnerReferralCodes.vue?vue&type=template&id=06a1b428&scoped=true"
import script from "./PartnerReferralCodes.vue?vue&type=script&lang=ts"
export * from "./PartnerReferralCodes.vue?vue&type=script&lang=ts"
import style0 from "./PartnerReferralCodes.vue?vue&type=style&index=0&id=06a1b428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a1b428",
  null
  
)

export default component.exports